import React, { Component } from 'react';

import MenuItem from '../MenuItem/MenuItem';

import './Menu.scss';

const items = [
  {
    title: 'e-commerce',
    active: true
  },
  {
    title: 'подписка',
    active: false,
    hidden: true
  },
  {
    title: 'custom',
    active: false,
    hidden: true
  }
];

class Menu extends Component {
  get menu() {
    return items.map((item, index) => {
      return !item.hidden && <MenuItem className="menu__item" config={item} key={index}/>
    })
  }

  render() {
    return (
      <div className="menu">
        <ul className="menu__list">
          {
            this.menu
          }
        </ul>
      </div>
    )
  }    
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js